import { api } from '../../../servicesGlobais/api'
import { Time, TimeFormData, TimeFilters, TimeConfiguracao } from '../tipos/time'

function normalizeTime(backend: any): Time {
  return {
    id: Number(backend.id ?? backend.Id ?? 0),
    descricao: backend.descricao ?? backend.Descricao ?? '',
    externo: backend.externo ?? backend.Externo ?? false,
  }
}

function convertToFormData(backend: any): TimeFormData {
  const t = normalizeTime(backend)
  return { id: t.id, descricao: t.descricao, externo: t.externo }
}

function convertToBackend(data: TimeFormData) {
  return {
    id: data.id ?? 0,
    descricao: data.descricao,
    externo: data.externo ?? false,
  }
}

export const timeService = {
  async listarTimes(filters?: TimeFilters): Promise<Time[]> {
    const params = new URLSearchParams()
    if (filters?.search) params.append('search', filters.search)
    const query = params.toString()
    const list = await api.get<any[]>(`/Time${query ? `?${query}` : ''}`)
    return Array.isArray(list) ? list.map(normalizeTime) : []
  },

  async getTimeById(id: number): Promise<TimeFormData> {
    const time = await api.get<any>(`/Time/${id}`)
    return convertToFormData(time)
  },

  async criarTime(data: TimeFormData): Promise<Time> {
    const payload = convertToBackend(data)
    const created = await api.post<any>('/Time', payload)
    return normalizeTime(created)
  },

  async atualizarTime(id: number, data: TimeFormData): Promise<Time> {
    const payload = convertToBackend({ ...data, id })
    const updated = await api.put<any>(`/Time/${id}`, payload)
    return normalizeTime(updated)
  },

  async excluirTime(id: number): Promise<void> {
    await api.delete(`/Time/${id}`)
  },

  async listarTimesConfiguracao(): Promise<TimeConfiguracao[]> {
    const list = await api.get<any[]>('/Time/configuracao')
    if (!Array.isArray(list)) return []
    return list.map((item: any) => ({
      id: Number(item.id ?? item.Id ?? 0),
      descricao: item.descricao ?? item.Descricao ?? '',
      externo: item.externo ?? item.Externo ?? false,
      dataCriacao: item.dataCriacao ?? item.DataCriacao ?? null,
      integrantes: (item.integrantes ?? item.Integrantes ?? []).map((i: any) => ({
        nome: i.nome ?? i.Nome ?? '',
      })),
    }))
  },
}
